import axios from 'axios';

// Configuración de las URLs de la API
const API_URLS = {
    production: 'https://centro-infantil-mijardin.onrender.com/api/evaluaciones',
    development: 'http://localhost:5000/api/evaluaciones'
};

// Determinar la URL base según el entorno
const API_URL = process.env.NODE_ENV === 'production' ? API_URLS.production : API_URLS.development;

// Configuración global de axios
axios.defaults.withCredentials = true;

// Función para obtener todos los niños
export const obtenerTodosLosNinos = async () => {
    try {
        const response = await axios.get(`${API_URL}/obtener/ninos`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        // Asegurarse de que los datos incluyan el estado de matrícula
        if (response.data.success && response.data.data) {
            return {
                success: true,
                data: response.data.data.map(nino => ({
                    ...nino,
                    estado_matricula: nino.estado_matricula || 'Sin matrícula'
                }))
            };
        }
        return response.data;
    } catch (error) {
        throw new Error('Error al obtener la lista de niños');
    }
};

// Función para obtener un niño por su ID
export const obtenerNinoPorId = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/obtener/nino/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al obtener los datos del niño');
    }
};


// Función para buscar un niño por nombre o cédula
export const buscarNiño = async (query) => {
    try {
        const response = await axios.get(`${API_URL}/buscar/child`, {
            params: { query },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data; // Asegúrate que la respuesta incluye la fecha de nacimiento
    } catch (error) {
        throw new Error('Error al buscar al niño');
    }
};

// Función para obtener el grupo de edad basado en la fecha de nacimiento
export const obtenerGrupoEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    const edadMeses = (hoy.getFullYear() - nacimiento.getFullYear()) * 12 + hoy.getMonth() - nacimiento.getMonth();

    if (edadMeses >= 6 && edadMeses <= 9) {
        return '6-9 meses';
    }
    // Puedes agregar más rangos de edad si es necesario.
    return 'Grupo no determinado';
};

export const obtenerEvaluaciones = async (idChild = null) => {
    try {
        let url = `${API_URL}/recuperar/evaluacion`;
        if (idChild) {
            url += `?idChild=${idChild}`;
        }
        
        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al obtener las evaluaciones');
    }
};

// Función para obtener evaluación por idChild
export const obtenerEvaluacionIdChild = async (idChild) => {
    try {
        const response = await axios.get(`${API_URL}/recuperar/evaluacion/idChild/${idChild}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al obtener la evaluación por idChild');
    }
};

export const registrarEvaluaciones = async (evaluacionData) => {
    try {
        // Validar que tengamos datos para procesar
        if (!evaluacionData?.datosChild?.id_child || 
            !evaluacionData?.datosCentro?.id_centro || 
            !evaluacionData?.datosEvaluacion?.fecha || 
            !evaluacionData?.ambitos) {
            throw new Error('Faltan datos necesarios para registrar la evaluación');
        }

        const response = await axios.post(
            `${API_URL}/registrar/evaluacion`,
            evaluacionData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        if (response.data.success) {
            return {
                success: true,
                message: 'Evaluación registrada exitosamente.',
                data: {
                    evaluacion: response.data.data,
                    datosChild: evaluacionData.datosChild,
                    datosCentro: evaluacionData.datosCentro,
                    datosEvaluacion: evaluacionData.datosEvaluacion,
                    ambitos: evaluacionData.ambitos
                }
            };
        } else {
            throw new Error(response.data.message || 'Error al registrar la evaluación');
        }

    } catch (error) {
        throw new Error(error.response?.data?.message || error.message || 'Error al registrar la evaluación');
    }
};



export const obtenerAmbitoAprendizaje = async () => {
    try {
        const response = await axios.get(`${API_URL}/recuperar/ambitoAprendizaje`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,  
            }
        });
        return response.data; 
    } catch (error) {
        throw new Error('Error al obtener las evaluaciones');
    }
};


export const registrarAmbitoAprendizaje = async (formData) => {
    try {
        // Enviar los datos con la estructura correcta
        const datos = {
            datosAmbitoAprendizaje: formData  // Usamos directamente formData
        };

        const response = await axios.post(`${API_URL}/registrar/ambitoAprendizaje`, datos, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;  
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al registrar el ámbito de aprendizaje');
        } else {
            throw new Error('Error al registrar el ámbito de aprendizaje');
        }
    }
};


export const editarAmbitoAprendizaje = async (idAmbito, datosActualizados) => {
    try {
        // Modificar la estructura para que coincida con el formato que espera la API
        const datos = {
            datosAmbitoAprendizaje: datosActualizados
        };

        const response = await axios.put(`${API_URL}/editar/ambitoAprendizaje/${idAmbito}`, datos, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;  
    } catch (error) {
        throw new Error('Error al editar el ámbito de aprendizaje');
    }
};
// Función para eliminar un ámbito de aprendizaje
export const eliminarAmbitoAprendizaje = async (idAmbito) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar/ambitoAprendizaje/${idAmbito}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`, 
            }
        });
        return response.data;  
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al eliminar el ámbito de aprendizaje');
        } else {
            throw new Error('Error al eliminar el ámbito de aprendizaje');
        }
    }
};

// Función para obtener reportes de progreso por id_evaluacion
export const obtenerReporteProgreso = async (id_evaluacion) => {
    try {
        const response = await axios.get(`${API_URL}/obtener/reporteProgreso/${id_evaluacion}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });

        return response.data;

    } catch (error) {
        // Si el error es 404, significa que no existen los reportes, permitiendo la creación de nuevos
        if (error.response && error.response.status === 404) {
            return null; // No hay reportes, retornar null para que los nuevos puedan ser generados
        }
        
        throw new Error(error.response?.data?.message || error.message || 'Error al obtener los reportes de progreso');
    }
};

// Función para obtener reportes resumen por id_evaluacion
export const obtenerReporteResumen = async (id_evaluacion) => {
    try {
        const response = await axios.get(`${API_URL}/obtener/reporteResumen/${id_evaluacion}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });

        return response.data;

    } catch (error) {
        // Manejar específicamente el caso de reporte no encontrado
        if (error.response && (error.response.status === 404 || 
            (error.response.status === 500 && error.response.data?.message?.includes('no encontrado')))) {
            return null;
        }
        
        throw new Error(error.response?.data?.message || error.message || 'Error al obtener el reporte resumen');
    }
};

// Función para registrar un nuevo reporte de progreso
export const registrarReporteProgreso = async (reporteData) => {
    try {
        const response = await axios.post(
            `${API_URL}/registrar/reporteProgreso`,
            reporteData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        if (response.data.success) {
            return {
                success: true,
                message: 'Reporte de progreso registrado con éxito',
                data: response.data.data
            };
        } else {
            throw new Error(response.data.message || 'Error al registrar el reporte de progreso');
        }

    } catch (error) {
        throw new Error(error.response?.data?.message || error.message || 'Error al registrar el reporte de progreso');
    }
};


// Función para registrar un nuevo reporte resumen
export const registrarReporteResumen = async (reporteData) => {
    try {
        const response = await axios.post(
            `${API_URL}/registrar/reporteResumen`,
            reporteData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        if (response.data.success) {
            return {
                success: true,
                message: 'Reporte resumen registrado con éxito',
                data: response.data.data
            };
        } else {
            throw new Error(response.data.message || 'Error al registrar el reporte resumen');
        }

    } catch (error) {
        throw new Error(error.response?.data?.message || error.message || 'Error al registrar el reporte resumen');
    }
};
// Función para eliminar un ámbito de aprendizaje
export const deleteEvaluacion = async (id_evaluacion) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar/evaluacion/${id_evaluacion}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`, 
            }
        });
        return response.data;  
    } catch (error) {
        throw new Error('Error al eliminar la evaluación');
    }
};

// Función para eliminar un ámbito completo con todos sus indicadores
export const eliminarAmbitoCompleto = async (idAmbito) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar/ambitoCompleto/${idAmbito}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`, 
            }
        });
        return response.data;  
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al eliminar el ámbito completo');
        } else {
            throw new Error('Error al eliminar el ámbito completo');
        }
    }
};
